import React from 'react';
import { Mail, Phone, MapPin, Send, PhoneCall, ExternalLink } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="cb-contact-section">
      <div className="cb-contact-glow"></div>
      <div className="container">
        <div className="cb-section-title-wrap">
          <div className="cb-studio-tag">[ 05 // INQUIRY & CONNECT ]</div>
          <h2 className="cb-section-title">
            Contact us
          </h2>
        </div>

        <div className="cb-contact-grid">
          <div className="cb-contact-card">
            <div className="cb-contact-icon">
              <Mail size={26} strokeWidth={1.75} />
            </div>
            <h3 className="cb-contact-title">Email</h3>
            <p className="cb-contact-value">contact@chembioai.org</p>
            <a href="mailto:contact@chembioai.org" className="cb-contact-action-btn">
              <Send size={15} strokeWidth={2} />
              <span>Send Email</span>
            </a>
          </div>

          <div className="cb-contact-card">
            <div className="cb-contact-icon">
              <Phone size={26} strokeWidth={1.75} />
            </div>
            <h3 className="cb-contact-title">Phone</h3>
            <p className="cb-contact-value">+91 9498866488</p>
            <a href="tel:+919498866488" className="cb-contact-action-btn">
              <PhoneCall size={15} strokeWidth={2} />
              <span>Call Us</span>
            </a>
          </div>

          <div className="cb-contact-card">
            <div className="cb-contact-icon">
              <MapPin size={26} strokeWidth={1.75} />
            </div>
            <h3 className="cb-contact-title">Address</h3>
            <p className="cb-contact-value">
              B Block, Asian Sun City, 309, Forest Dept Colony, Kondapur, Hyderabad, Telangana 500084
            </p>
            <a 
              href="https://maps.google.com/?q=Asian+Sun+City,+Kondapur,+Hyderabad" 
              target="_blank" 
              rel="noreferrer" 
              className="cb-contact-action-btn"
            >
              <ExternalLink size={15} strokeWidth={2} />
              <span>View Location</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;